(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/regenerator", "@babel/runtime/helpers/slicedToArray", "@babel/runtime/helpers/asyncToGenerator", "@babel/runtime/helpers/defineProperty", "idb-keyval", "../constants", "../request", "./cache", "./inapp.schema"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/regenerator"), require("@babel/runtime/helpers/slicedToArray"), require("@babel/runtime/helpers/asyncToGenerator"), require("@babel/runtime/helpers/defineProperty"), require("idb-keyval"), require("../constants"), require("../request"), require("./cache"), require("./inapp.schema"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.regenerator, global.slicedToArray, global.asyncToGenerator, global.defineProperty, global.idbKeyval, global.constants, global.request, global.cache, global.inapp);
    global.request = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _regenerator, _slicedToArray2, _asyncToGenerator2, _defineProperty2, _idbKeyval, _constants, _request, _cache, _inapp) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.requestMessages = _exports.requestInAppMessages = void 0;
  _regenerator = _interopRequireDefault(_regenerator);
  _slicedToArray2 = _interopRequireDefault(_slicedToArray2);
  _asyncToGenerator2 = _interopRequireDefault(_asyncToGenerator2);
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _inapp = _interopRequireDefault(_inapp);
  function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
  function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /* eslint-disable no-unreachable */
  var requestInAppMessages = _exports.requestInAppMessages = function requestInAppMessages(_ref) {
    var latestCachedMessageId = _ref.latestCachedMessageId,
      payload = _ref.payload;
    return (0, _request.baseIterableRequest)({
      method: 'GET',
      /** @note TBD: Parameter will be enabled once new endpoint is ready */
      // url: options?.useLocalCache ? CACHE_ENABLED_GETMESSAGES_PATH : GETMESSAGES_PATH,
      url: _constants.GETMESSAGES_PATH,
      validation: {
        params: _inapp["default"]
      },
      params: _objectSpread(_objectSpread({}, payload), {}, {
        platform: _constants.WEB_PLATFORM,
        SDKVersion: _constants.SDK_VERSION,
        latestCachedMessageId: latestCachedMessageId
      })
    });
  };
  var requestMessages = _exports.requestMessages = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(_ref2) {
      var payload, cachedMessages, latestCachedMessageId, latestCreatedAtTimestamp, response, inAppMessages, allMessages, newMessages, cachedMessagesToDelete, _err$response$data$cl, _err$response, _err$response$data, _err$response$data$cl2, _err$response2, _err$response2$data;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            payload = _ref2.payload;
            return _context.abrupt("return", requestInAppMessages({
              payload: payload
            }));
          case 5:
            cachedMessages = _context.sent;
            latestCreatedAtTimestamp = 0;
            cachedMessages.forEach(function (_ref4) {
              var _ref5 = (0, _slicedToArray2["default"])(_ref4, 2),
                cachedMessageId = _ref5[0],
                cachedMessage = _ref5[1];
              if (cachedMessage.createdAt > latestCreatedAtTimestamp) {
                latestCachedMessageId = cachedMessageId;
                latestCreatedAtTimestamp = cachedMessage.createdAt;
              }
            });

            /**
             * Call getMessages with latestCachedMessageId to get the message delta
             * (uncached messages have full detail, rest just have messageId)
             */
            _context.next = 10;
            return requestInAppMessages({
              latestCachedMessageId: latestCachedMessageId,
              payload: payload
            });
          case 10:
            response = _context.sent;
            inAppMessages = response.data.inAppMessages;
            /** Combine cached messages with NEW messages in delta response */
            allMessages = [];
            newMessages = [];
            inAppMessages === null || inAppMessages === void 0 ? void 0 : inAppMessages.forEach(function (inAppMessage) {
              /**
               * If message in response has no content property, then that means it is
               * older than the latest cached message and should be retrieved from the
               * cache using the messageId
               *
               * Expecting messages with no content to look like the last 2 messages...
               * {
               *   inAppMessages: [
               *     { ...messageWithContentHasFullDetails01 },
               *     { ...messageWithContentHasFullDetails02 },
               *     { messageId: 'messageWithoutContentHasNoOtherProperties01' },
               *     { messageId: 'messageWithoutContentHasNoOtherProperties02' }
               *   ]
               * }
               */
              if (!inAppMessage.content) {
                var cachedMessage = cachedMessages.find(function (_ref6) {
                  var _ref7 = (0, _slicedToArray2["default"])(_ref6, 1),
                    messageId = _ref7[0];
                  return inAppMessage.messageId === messageId;
                });
                if (cachedMessage) allMessages.push(cachedMessage[1]);
              } else {
                allMessages.push(inAppMessage);
                if (inAppMessage.messageId) {
                  newMessages.push({
                    messageId: inAppMessage.messageId,
                    message: inAppMessage
                  });
                }
              }
            });

            /** Delete messages not present in fetch from cache */
            cachedMessagesToDelete = (0, _cache.getCachedMessagesToDelete)(cachedMessages, inAppMessages);
            _context.prev = 16;
            _context.next = 19;
            return (0, _idbKeyval.delMany)(cachedMessagesToDelete);
          case 19:
            _context.next = 24;
            break;
          case 21:
            _context.prev = 21;
            _context.t0 = _context["catch"](16);
            // eslint-disable-next-line no-console
            console.warn('Error deleting messages from the browser cache', (_err$response$data$cl = _context.t0 === null || _context.t0 === void 0 ? void 0 : (_err$response = _context.t0.response) === null || _err$response === void 0 ? void 0 : (_err$response$data = _err$response.data) === null || _err$response$data === void 0 ? void 0 : _err$response$data.clientErrors) !== null && _err$response$data$cl !== void 0 ? _err$response$data$cl : _context.t0);
          case 24:
            _context.next = 26;
            return (0, _cache.addNewMessagesToCache)(newMessages);
          case 26:
            return _context.abrupt("return", _objectSpread(_objectSpread({}, response), {}, {
              data: {
                inAppMessages: allMessages
              }
            }));
          case 29:
            _context.prev = 29;
            _context.t1 = _context["catch"](2);
            // eslint-disable-next-line no-console
            console.warn('Error requesting in-app messages', (_err$response$data$cl2 = _context.t1 === null || _context.t1 === void 0 ? void 0 : (_err$response2 = _context.t1.response) === null || _err$response2 === void 0 ? void 0 : (_err$response2$data = _err$response2.data) === null || _err$response2$data === void 0 ? void 0 : _err$response2$data.clientErrors) !== null && _err$response$data$cl2 !== void 0 ? _err$response$data$cl2 : _context.t1);
          case 32:
            return _context.abrupt("return", requestInAppMessages({
              payload: payload
            }));
          case 33:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 29], [16, 21]]);
    }));
    return function requestMessages(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
});